import React from "react";
import { useTranslation } from "react-i18next";
import { FaFacebookF, FaTwitter, FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import "./FooterSection.css";

const FooterSection = () => {
  const { t } = useTranslation(); 

  const handleSubscribe = async () => {
  const email = document.querySelector(".cm-footer-newsletter-input").value;

  const res = await fetch("https://cmpranesh-admk.com/Mail/subscribe.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ email })
  });

  const data = await res.json();
  alert(data.message);
};


  return (
    <footer className="cm-footer-wrapper">
      <div className="cm-footer-container">
        
        {/* LEFT - ABOUT */}
        <div className="cm-footer-about">
          <h3 className="cm-footer-about-title">{t("footer.aboutTitle")}</h3>
          <p className="cm-footer-about-text">{t("footer.aboutText")}</p>

          <div className="cm-footer-social-icons">
            <a className="cm-footer-social-icon"><FaFacebookF /></a>
            <a className="cm-footer-social-icon"><FaTwitter /></a>
          </div>
        </div>

        {/* CENTER - FACEBOOK */}
<div className="cm-footer-facebook">
  <h3 className="cm-footer-facebook-title">
    {t("footer.facebookTitle")}
  </h3>

  <iframe
    className="cm-footer-facebook-iframe"
    src="https://www.facebook.com/plugins/page.php?href=https://www.facebook.com/pranesh.masilamani/&tabs=timeline&width=350&height=400&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true"
    width="100%"
    height="370"
    style={{ border: "none", overflow: "hidden" }}
    scrolling="no"
    frameBorder="0"
    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
  ></iframe>
</div>


        {/* RIGHT - NEWSLETTER */}
        <div className="cm-footer-newsletter">
          <h3 className="cm-footer-newsletter-title">{t("footer.newsletterTitle")}</h3>
          <p className="cm-footer-newsletter-sub">{t("footer.newsletterSub")}</p>

          <div className="cm-footer-newsletter-input-wrap">
            <input
              type="email"
              className="cm-footer-newsletter-input"
              placeholder={t("footer.placeholderEmail")}
            />
            <button
  className="cm-footer-newsletter-btn"
  onClick={handleSubscribe}
>
  {t("footer.subscribeBtn")}
</button>
          </div>

          <div className="cm-footer-whatsapp">
            <div className="cm-footer-whatsapp-icon"><FaWhatsapp /></div>
            <div>
              <p className="cm-footer-whatsapp-text">{t("footer.whatsappJoin")}</p>
              <p className="cm-footer-whatsapp-num">+91 99446 62747</p>
            </div>
          </div>
        </div>
      </div>

      {/* BOTTOM INFO */}
      <div className="cm-footer-bottom">
        <div className="cm-footer-bottom-item">
          <FaMapMarkerAlt className="cm-footer-bottom-icon" />
          <p>{t("footer.address")}</p>
        </div>

        <div className="cm-footer-bottom-item">
          <FaEnvelope className="cm-footer-bottom-icon" />
          <p>info@cmpranesh-admk.com</p>
        </div>

        <div className="cm-footer-bottom-item">
          <FaPhoneAlt className="cm-footer-bottom-icon" />
          <p>+91 99446 62747</p>
        </div>
      </div>

      <div className="cm-footer-copy-bg">
        <div className="cm-footer-copy">
          <p>{t("footer.copyRight")}</p>
          <p>{t("footer.poweredBy")}</p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
